'use client'
import FAQAccordion from './FAQAccordion'
import { CtaButton } from '@/app/lib/Button';

const faqData = [
  {
    question: "What are the courses we offer?",
    answer: `<p>We offer a wide range of expert-led online courses designed to help you achieve your personal and professional goals. Our course catalog is diverse, covering key areas in Finance, Risk-analysis and Finance Modelling. </p>
    \n<br/>
    <p></p>
    <p>You can explore popular subjects such as:</p>
    \n
    <ul>
      <li> Financial Risk Manager (FRM)   : Quantitative Analysis,Fixed Income,Portfolio Management .....</li>
      <li> Chartered Financial Analyst (CFA)  : Quantitative Analysis, Financial Statement Analysis, Fixed Income ....</li>
      <li> Python  : coming soon</li>
    </ul>`,
  },
  {
    question: "Can I enroll in multiple courses at once?",
    answer: `<p>Yes, you can absolutely enroll in multiple courses at once! We encourage continuous learning and many of our students take simultaneous courses to accelerate their skill development.</p>
    \n<br/>
    <p>You can manage your progress for all enrolled courses directly from your student dashboard. Furthermore, we often offer course bundles or special discounts for learners who wish to purchase several courses together.</p>`,
  },
  {
    question: "Can I download course material for offline access?",
    answer: `<p>We understand that you need flexibility in your learning schedule. That's why many of our courses offer downloadable course materials for offline access.</p>
    \n<br/>
    <p>Typically, resources such as PDF lecture notes, presentation slides, code samples, and worksheets] can be saved to your device. While video lectures are primarily designed for streaming to provide an optimal experience</p>`,
  },
  {
    question: "What kind of support can I expect from instructors?",
    answer: `<p>Our instructors are dedicated to your success and provide robust student support. While the type of interaction can vary by course, you can generally expect:</p>
    \n<br/>
    <ul>
    <li> Q&A Forums  : Each course has a dedicated discussion forum where you can post questions and get answers from your instructor and fellow students.</li>
    <li> Direct Messaging  : Some courses offer the ability to contact the instructor directly for specific queries.</li>
    <li> Live Sessions  : Many of our premium courses include live Q&A sessions or webinars where you can interact with the instructor in real-time.</li>
    <li> Assignment Feedback  : For courses with practical assignments, instructors provide constructive feedback and grades to help you improve.</li>
    </ul>
    <p>Our goal is to ensure you never feel stuck.   You will always have access to the course assistance you need to succeed.</p>`,
  },
  {
    question: "Are there any prerequisited for the courses?",
    answer: `<p>Yes, prerequisites vary depending on the course. Our programs are designed for different skill levels:</p>
    \n<br/>
    <ul>
    <li> Introductory Courses  : These are generally open to everyone with no prior experience required.</li>
    <li> Advanced & Certification Courses  : These may have specific educational or professional experience requirements to ensure you are ready for the advanced curriculum.</li>
    </ul>
    <p>All specific requirements are clearly listed on each individual course page. We recommend reviewing the details there to find the perfect fit for your background and goals.</p>`,
  },
];

const FAQsection = () => {
  return (
    <section className='bg-gradient-to-b from-[#E9E9E9] to-[#ffffff] w-full py-[72px] lg:py-[96px] px-[16px] lg:px-[80px]'>
    <div className='flex flex-col gap-[54px] md:gap-[60px] items-center'>
    <div className='flex flex-col gap-[40px] items-center'>
      <div className="flex flex-col items-center gap-[24px] lg:gap-[32px]">
          <div>
            <h2 className="text-[38px] lg:text-[47px] font-[600] text-center">
             Everything You Need to Know!
            </h2>
          </div>
          <div>
            <h3 className="text-[24px] lg:text-[21px] font-[400] text-center leading-[120%]">
              Unlock your true potential and discover a world of opportunities that align with your skills, interests, and aspirations
            </h3>
          </div>
        </div>
        <div className='w-full'>
          <FAQAccordion data={faqData} />
        </div>
        
        <div className='w-full md:w-auto'>
          <CtaButton text={"View All"} />
        </div>
    </div>
    </div>
    </section>
  )
}

export default FAQsection
